module.exports = __webpack_public_path__ + "static/media/CryptoFund_track_fund1.c223bfd6.svg";